
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  handleGo(item: string) {
    switch (item) {
      case 'calligraphy':
        window.open('/activitys/calligraphy')
        return
      case 'chinaPaint':
        window.open('/activitys/paint_basic_2024')
        return
      case 'special':
        window.open('/product/list?typeCurrent=2&directionCurrent=0')
        return
      case 'dayCourse':
        window.open('/activitys/daycourse')
        return
      case 'selfCourse':
        window.open('/product/list?typeCurrent=4&directionCurrent=0')
        return
      case 'showCourse':
        window.open('/show/activity')
        return
      default:
        return
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
